import { createAsyncThunk } from '@reduxjs/toolkit'
import { api } from '../../services'

export const fetchReferrals = createAsyncThunk('referrals/fetchReferrals', async (requestData: any) => {
  return api.getReferrals(requestData)
})
